import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Spin } from "antd";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import styles from "./IndretIntroduccio.module.css";
import IndretFormulari from "./IndretFormulari";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import {
  getIdIndretLlista,
  getPeticioEnviarFormulariIndretEnCurs
} from "../../reducers";
import {
  indretIntroduccioDescartarCanvis,
  indretIntroduccioEnviarFormulari
} from "../../actions";

import { rutaIndrets, rutaDetallIndret } from "../../routes";

class IndretIntroduccio extends Component {
  generarBotoCancelar() {
    const {
      idIndret,
      peticioEnviarFormulariEnCurs,
      indretIntroduccioDescartarCanvis
    } = this.props;

    const ruta = idIndret === null ? rutaIndrets : rutaDetallIndret;
    const onClick = indretIntroduccioDescartarCanvis;

    return (
      <Link to={ruta}>
        <Button
          size="large"
          disabled={peticioEnviarFormulariEnCurs}
          onClick={onClick}
        >
          Cancel·lar
        </Button>
      </Link>
    );
  }

  render() {
    const {
      history,
      peticioEnviarFormulariEnCurs,
      indretIntroduccioEnviarFormulari
    } = this.props;

    const botoCancelar = this.generarBotoCancelar();

    return (
      <Spin
        spinning={peticioEnviarFormulariEnCurs}
        delay={RETARD_MILISEGONS_APARICIO_SPINNER}
      >
        <div className={styles.observadorIntroduccioDetall}>
          <div className={styles.observadorIntroduccioDetallContenidor}>
            <IndretFormulari esEditable={true} />
          </div>
          <div className={styles.observadorIntroduccioDetallBotons}>
            <Button
              type="primary"
              size="large"
              disabled={peticioEnviarFormulariEnCurs}
              onClick={() => indretIntroduccioEnviarFormulari(history)}
            >
              Guardar
            </Button>
            {botoCancelar}
          </div>
        </div>
      </Spin>
    );
  }
}

IndretIntroduccio.propTypes = {
  idIndret: PropTypes.number,
  peticioEnviarFormulariEnCurs: PropTypes.bool,
  indretIntroduccioDescartarCanvis: PropTypes.func,
  indretIntroduccioEnviarFormulari: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    idIndret: getIdIndretLlista(state),
    peticioEnviarFormulariEnCurs: getPeticioEnviarFormulariIndretEnCurs(state)
  };
};

const mapDispatchToProps = {
  indretIntroduccioDescartarCanvis,
  indretIntroduccioEnviarFormulari
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(IndretIntroduccio)
);
